import React, { useState } from 'react'
import DownloadButton from '../download/DownloadIconMenu'

export default function Download({loading=false, gridRef, fileName='SSA', rowData}: any) {
     const [isDownloading, setIsDownloading] = useState(false);

     const handleDownload = async (type: "excel" | "csv" = "excel") => {
    if (!gridRef.current?.api || loading || isDownloading) return;

    try {
      setIsDownloading(true);

      // Allow UI repaint
      await new Promise((resolve) => setTimeout(resolve, 0));

      const api = gridRef.current.api;

      // check if any row is selected
      const selectedRows = api.getSelectedRows();
      const onlySelected = selectedRows.length > 0;

      const commonParams = {
        onlySelected, //  magic line
      };

      if (type === "csv") {
        api.exportDataAsCsv({
          fileName: `${fileName}.csv`,
          ...commonParams,
        });
      } else {
        api.exportDataAsExcel({
          fileName: `${fileName}.xlsx`,
          sheetName: fileName,
          ...commonParams,
        });
      }
    } finally {
      // Reset downloading state after a short delay
      setTimeout(() => {
        setIsDownloading(false);
      }, 500); // reduce delay if needed
    }
  };
  return (
   <DownloadButton
             loading={isDownloading}
             disabled={loading || isDownloading || !rowData?.length}
             onExcel={() => handleDownload("excel")}
             onCsv={() => handleDownload("csv")}
           />
  )
}
